// extracted by mini-css-extract-plugin
export default {"p":"d3cb1c5dbe _48abb64803 _7e20bb2003","clr":"_4cedfb963a","dls":"_27dc6690ad"};